module.exports = __webpack_public_path__ + "static/media/RABBIT.2f006b6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/items/RABBIT.png
// module id = 97
// module chunks = 48